import React, { useState } from "react";
import { Box, Grid, Paper, Stack, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";
import request from "src/utils/request";
import { Helmet } from "react-helmet";
import { LoadingButton } from "@mui/lab";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import { useAuth } from "src/components/providers/auth-context";
import Flex from "../../components/flex";
import UpgradeCardPro from "./upgrade-card-pro";
import UpgradeCardTeam from "./upgrade-card-team";
import UpgradeCardEnterprise from "./upgrade-card-enterprise";
import Portal from "../../components/portal";
import DemoBarDemo from "../../components/demo-bar-demo";
import Auth from "../../services/auth";

const Upgrade = () => {
    const { isUserPayingCustomer } = useAuth();
    const [coupon, setCoupon] = useState();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    if (isUserPayingCustomer) return <Navigate to="/subscription" />;

    React.useEffect(() => {
        request(`/api/users/me/achievements`, {
            method: "POST",
            body: JSON.stringify(["visitSubscriptions"]),
        });
    }, []);

    const handleCouponSubmit = async () => {
        try {
            setLoading(true);
            await request(`/api/payments/coupon`, {
                method: "POST",
                body: JSON.stringify({ coupon }),
            });
            Auth.relog();
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Flex
            width="100%"
            justifyContent="center"
            margin={["20px", 0, 0, 0]}
            style={{ minHeight: "100%" }}
            flexDirection="column"
        >
            <Helmet>
                <title>Adadot - Upgrade</title>
            </Helmet>
            <Portal>
                <DemoBarDemo />
            </Portal>
            <Paper style={{ borderRadius: "8px", padding: "12px", width: "826px" }}>
                <Stack
                    direction="row"
                    spacing={1}
                    mb={2}
                    mt={2}
                    alignItems="center"
                    justifyContent="space-between"
                    style={{ width: "100%" }}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Box
                            style={{
                                height: "44px",
                                width: "44px",
                                backgroundColor: "#3d3d3d",
                                borderRadius: "22px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <LocalActivityIcon />
                        </Box>
                        <p style={{ fontSize: "12px" }}>
                            Enter your coupon here to activate your subscription
                        </p>
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        <TextField
                            id="coupon-id"
                            label="Coupon code"
                            variant="outlined"
                            value={coupon}
                            helperText={error}
                            error={error}
                            size="small"
                            onChange={(event) => {
                                setError();
                                setCoupon(event.target.value);
                            }}
                            onKeyPress={(event) => {
                                if (event.key === "Enter") {
                                    handleCouponSubmit();
                                }
                            }}
                            InputProps={{
                                sx: {
                                    fontSize: "12px",
                                    fontWeight: 300,
                                    padding: "3.5px",
                                },
                            }}
                            InputLabelProps={{
                                sx: {
                                    fontSize: "12px",
                                    fontWeight: 300,
                                    padding: "3.5px",
                                    "&.MuiOutlinedInput-notchedOutline": {
                                        fontSize: "13px",
                                    },
                                },
                            }}
                        />
                        <LoadingButton loading={loading} onClick={() => handleCouponSubmit()}>
                            Activate Coupon
                        </LoadingButton>
                    </Stack>
                </Stack>
            </Paper>
            <Grid container spacing={3} mt={1} justifyContent="center">
                <Grid item>
                    <UpgradeCardPro />
                </Grid>
                <Grid item>
                    <Paper>
                        <UpgradeCardTeam />
                    </Paper>
                </Grid>
                <Grid item>
                    <Paper>
                        <UpgradeCardEnterprise />
                    </Paper>
                </Grid>
            </Grid>
        </Flex>
    );
};

export default Upgrade;
